import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyACgWbucZVNh14xiSmzl241PMX_Yf4Sdp8",
    authDomain: "hitractfirebase.firebaseapp.com",  
    databaseURL: "https://hitractfirebase.firebaseio.com",
    projectId: "hitractfirebase",
    storageBucket: "hitractfirebase.appspot.com",
    messagingSenderId: "249582935278",
    appId: "1:249582935278:web:b920874ee0997acff367ff",
    measurementId: "G-WSC3SFLM58"
};
  

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
console.log('firebaseApp', firebaseApp)